import NotificationPageWrapper from './NotificationPageWrapper';

export default NotificationPageWrapper;
